// @TODO: ensure this works with swipe gesture on native
// @TODO: combine with ../SideDrawer
/**
 * Ryan O'Dowd
 * 2025-05-11
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Drawer,
} from 'react-native-drawer-layout';
import {
  Keyboard,
} from 'react-native';
import React from 'react';
import ScreenWrapper from '@containers/ScreenWrapper';
import getStyles from './styles';
import hooks from '@hooks';

const SideDrawerWrapper = (props: SideDrawerProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <Drawer
      key={props.width}// when ipads change orientation, we need to re-render the side drawer
      drawerStyle={styles.drawerStyle}
      open={props.open}
      onOpen={() => {
        Keyboard.dismiss();
        props.setOpen(true);
      }}
      onClose={() => props.setOpen(false)}
      renderDrawerContent={() => props.sideDrawerContent}
    >
      <ScreenWrapper key={props.width}>
        {props.header}
        {props.homeContent}
      </ScreenWrapper>
      {props.translationSelectionDialog}
    </Drawer>
  );
};

class SideDrawerProps {
  width: number;
  header: React.ReactNode;
  homeContent: React.ReactNode;
  sideDrawerContent: React.ReactNode;
  translationSelectionDialog: React.ReactNode;
  open: boolean;
  setOpen: (open: boolean) => void;

  overlay?: React.ReactNode;
};

export default SideDrawerWrapper;
